import { PageHead } from "../components/PageHead.tsx";
import { AutoHeightTable } from "../components/table/AutoHeightTable.tsx";
import type { Raid } from "@/raids/rest/RaidSchema.ts";
import { useRaidColumns } from "@/raids/raidTable/columnsHelper.tsx";
import { Button, Tooltip } from "antd";
import { useGetRaidList } from "@/raids/rest/RaidQueries.ts";
import { PlusCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "@tanstack/react-router";
import { PageFullHeight } from "../layout/PageFullHeight.tsx";
import { RaidListTour } from "@/raids/tour/RaidListTour.tsx";

export function RaidList() {
  const { data, isLoading } = useGetRaidList();
  const navigate = useNavigate();

  function goToCreation() {
    void navigate({ to: "/raids/create" });
  }

  function showRecord(raid: Raid) {
    void navigate({
      to: "/raids/$raidId",
      params: { raidId: String(raid.id) },
    });
  }

  const columns = useRaidColumns();

  return (
    <PageFullHeight
      title={
        <PageHead
          title={"Raids"}
          rightComponent={
            <Tooltip title={"Neuen Raid erstellen"}>
              <Button
                data-tour="raid-create-btn"
                icon={<PlusCircleOutlined />}
                onClick={() => goToCreation()}
              >
                Erstellen
              </Button>
            </Tooltip>
          }
        />
      }
    >
      <AutoHeightTable<Raid>
        data={data ?? []}
        loading={isLoading}
        columns={columns}
        rowKey="id"
        enableVirtual={true}
        rowClassName={"cursor-pointer"}
        onRow={(raid) => ({
          onClick: () => showRecord(raid),
        })}
      />
      <RaidListTour />
    </PageFullHeight>
  );
}
